module.exports = __webpack_public_path__ + "static/Clip-0e456f8bcfb2f978246d14668fe68419.jpg";